

/** IE10 and IE11 requires the following for the Reflect API. */
//import 'core-js/es5/reflect';

//import "core-js";

//import 'core-js/es5/reflect';
/**
 * Required to support Web Animations `@angular/platform-browser/animations`.
 * Needed for: All but Chrome, Firefox and Opera. http://caniuse.com/#feat=web-animation
 **/
 import 'web-animations-js';  // Run `npm install --save web-animations-js`.

/**
 * By default, zone.js will patch all possible macroTask and DomEvents
 * user can disable parts of macroTask/DomEvents patch by setting following flags
 */

 // (window as any).__Zone_disable_requestAnimationFrame = true; // disable patch requestAnimationFrame
 // (window as any).__Zone_disable_on_property = true; // disable patch onProperty such as onclick
 // (window as any).__zone_symbol__BLACK_LISTED_EVENTS = ['scroll', 'mousemove']; // disable patch specified eventNames

 /*
 * in IE/Edge developer tools, the addEventListener will also be wrapped by zone.js
 * with the following flag, it will bypass `zone.js` patch for IE/Edge
 */
// (window as any).__Zone_enable_cross_context_check = true;

/***************************************************************************************************
 * Zone JS is required by default for Angular itself.
 */
import 'zone.js/dist/zone';  // Included with Angular CLI.



/***************************************************************************************************
 * APPLICATION IMPORTS
 */
// polyfill all `core-js` features:
import "core-js";
//// polyfill only stable `core-js` features - ES and web standards:
//import "core-js/stable";
//// polyfill only stable ES features:
import "core-js/es7";

//// if you want to polyfill `Set`:
//// all `Set`-related features, with ES proposals:
//import "core-js/features/set";
//// stable required for `Set` ES features and features from web standards
//// (DOM collections iterator in this case):
//import "core-js/stable/set";
//// only stable ES features required for `Set`:
//import "core-js/es/set";
//// the same without global namespace pollution:
////import Set from "core-js-pure/features/set";
////import Set from "core-js-pure/stable/set";
////import Set from "core-js-pure/es/set";

//// if you want to polyfill just required methods:
//import "core-js/features/set/intersection";
//import "core-js/stable/queue-microtask";
//import "core-js/es/array/from";

//// polyfill reflect metadata proposal:
//import "core-js/proposals/reflect-metadata";
//// polyfill all stage 2+ proposals:
//import "core-js/stage/2";




